import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Zombi smrt",
  "description": "",
  "published": "2007-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/zombi-smrt/swizec/330"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Internet je preplavljen z zombijevsko okuzbo in nasa dolznost je, da osvobodimo svet mrtve tiranije. Ce zelis pri tem cilju pomagati pojej modro tableto in pojdi `}<a parentName="p" {...{
        "href": "http://www.crazymonkeygames.com/PlayBoxheadRooms.php"
      }}>{`sem`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      